var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [
          _vm._v("Payments "),
          _vm.client
            ? _c("span", [_vm._v("– " + _vm._s(_vm.client.name))])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _vm.$userIsAdmin
          ? _c(
              "payment-list-filters",
              { attrs: { "apply-filters": _vm.handleApplyFiltersCallback } },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-primary pull-right",
                    attrs: {
                      slot: "button",
                      click: _vm.handleApplyFiltersCallback,
                      type: "submit",
                    },
                    slot: "button",
                  },
                  [_vm._v("\n        Search\n      ")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dashboard-block" },
          [
            _vm.fetchingPayments
              ? _c("pickstar-loading", { staticClass: "m-t-lg" })
              : [
                  _vm.haveNoPayments
                    ? _c("no-results", [
                        _c("div", [_vm._v("There are no payments.")]),
                        _vm._v(" "),
                        _vm.haveAppliedFilters && _vm.$userIsNotClient
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-default btn-sm m-t-sm",
                                on: { click: _vm.handleResetFiltersCallback },
                              },
                              [_vm._v("Reset Filters")]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "item-detail item-detail-payment list-links",
                    },
                    _vm._l(_vm.payments, function (payment) {
                      return _c("payment-list-item", {
                        key: payment.id,
                        attrs: { payment: payment },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "lazy-loading",
                    {
                      ref: "lazyLoading",
                      staticClass: "text-center",
                      attrs: {
                        loading: _vm.loading,
                        "reached-bottom": _vm.handleGetNextPaymentCallback,
                      },
                    },
                    [
                      _c("pickstar-loading", {
                        attrs: { slot: "loading" },
                        slot: "loading",
                      }),
                      _vm._v(" "),
                      _c("span", {
                        attrs: { slot: "finished" },
                        slot: "finished",
                      }),
                    ],
                    1
                  ),
                ],
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }